import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ViewIcon from "components/CustomIcons/View.js";
import DownloadIcon from "components/CustomIcons/Download.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// @material-ui/icons
import Download from "@material-ui/icons/CloudDownload";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomResource from "components/CustomResource/CustomResource";
import File from "components/CustomIcons/File";
import { Folder, Description } from "@material-ui/icons";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import {
  getOrdersByClient,
  getActiveOrdersByClient,
  getAgencyDataByClient,
} from "views/Services/OrdersService";

import { getResourcesAgent } from "views/Services/ResourcesService";

import {
  buttonStyleStatusPolicy,
  checkIfIsKiosko,
  isAgent
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { useTranslation } from "react-i18next";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
export default function Dashboard() {
  const { t } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const [agencyData, setAgencyData] = useState(null);
  const [resources, setResources] = useState(null);
  const [currentFiles, setCurrentFiles] = useState(null);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const cardStyleExpire = {
    border: "2px solid #F44336",
  };
  const cardStyleWarning = {
    border: "2px solid #FF9802",
  };
  const cardStyleSuccess = {
    border: "2px solid #4CAF50",
  };
  useEffect(() => {
    if (isAgent) {
      getResourceList();
    }
  }, [dispatch]);
  const getResourceList = async () => {
    const resultSubmit = await dispatch(getResourcesAgent({}));
    setResources(resultSubmit.payload.data);
  };

  const setFilesCategory = (category) => {
    const files = resources[category].map((file, index) => (
      <GridItem
        xs={12}
        sm={6}
        md={4}
        key={index}
        style={{ marginBottom: "20px", textAlign: "center" }}
      >
        <a
          href={`/admin/resourceFile/${category}/${file.name}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <GridContainer justify="center" alignItems="center">
            <GridItem xs={12} style={{ textAlign: "center" }}>
              <Description
                style={{
                  width: isXs ? "70px" : isSm ? "90px" : "120px",
                  height: isXs ? "70px" : isSm ? "90px" : "120px",
                  color: "#008670",
                }}
              />
            </GridItem>
            <GridItem xs={12} style={{ textAlign: "center", marginTop: 5 }}>
              <span
                className={`${classesPrincipal.font700} ${classesPrincipal.black}`}
              >
                {file.name}
              </span>
            </GridItem>
          </GridContainer>
        </a>
      </GridItem>
    ));
    setCurrentFiles(files);
  };

  const setAgentResources = () => {
    return (
      <>
        <GridItem xs={12} style={{ marginLeft: "20px", textAlign: "center" }}>
          <GridContainer style={{ justifyContent: "center" }} spacing={4}>
            {resources &&
              Object.entries(resources).map(([key, value]) => (
                <GridItem
                  xs={12}
                  sm={12}
                  md={3}
                  key={key}
                  onClick={() => setFilesCategory(key)}
                  style={{ cursor: "pointer" }}
                >
                  <GridContainer justify="center" alignItems="center">
                    <GridItem xs={12} style={{ textAlign: "center" }}>
                      <Folder
                        style={{
                          width: "200px",
                          height: "150px",
                          color: "#008670",
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} style={{ textAlign: "center" }}>
                      <span
                        className={`${classesPrincipal.font700} ${classesPrincipal.black}`}
                      >
                        {key}
                      </span>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              ))}
            <GridItem xs={12} style={{ marginTop: "5%" }}>
              <GridContainer>{currentFiles}</GridContainer>
            </GridItem>
          </GridContainer>
        </GridItem>
      </>
    );
  };

  const classes = useStyles();

  // Hooks
  const [showActivePolicies, setActivePolicies] = React.useState(false);
  const [showAllPolicies, setAllPolicies] = React.useState(false);
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const ActivePoliciesComponent = () => getActivePolicies();

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer
            style={{ padding: "20px 0px 40px 0px" }}
            justify="center"
          >
            {/* <Wizard
              steps={[
                {
                  stepName: "Active Policies",
                  stepComponent: <div>{getActivePolicies()}</div>,
                  stepId: "active",
                },
                {
                  stepName: "Expired Policies",
                  stepComponent: <div>{getActivePolicies()}</div>,
                  stepId: "expired",
                },
                {
                  stepName: "Saved Quotes",
                  stepComponent: <div>{getActivePolicies()}</div>,
                  stepId: "saved",
                },
              ]}
            />
            */}
            {isAgent && resources != null && (
              <GridItem xs={12}>
                <GridContainer>
                  <Card>{setAgentResources()}</Card>
                </GridContainer>
              </GridItem>
            )}
            {localStorage.getItem("userType") == 3 && <CustomResource />}
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
